/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Event } from '../models/Event';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EventService {
    /**
     * Create form submit event
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully created event
     * @throws ApiError
     */
    public static postEventForm(
        workspaceId: string,
        requestBody: {
            time: number;
            form_type?: string;
            form_id?: string;
            country?: string;
            email?: string;
            phone?: string;
            first_name?: string;
            last_name?: string;
            name?: string;
            session_id?: string;
            ip_address?: string;
            device?: string;
            website?: string;
            href?: string;
            utm_source?: string;
            utm_medium?: string;
            utm_campaign?: string;
            utm_content?: string;
            fbclid?: string;
            gclid?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event/form',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create transaction event
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully created event
     * @throws ApiError
     */
    public static postEventTransaction(
        workspaceId: string,
        requestBody: {
            time: number;
            parent_id?: string;
            transaction_id: string;
            transaction_type: string;
            transaction_amount: number;
            transaction_description: string;
            country?: string;
            email?: string;
            phone?: string;
            first_name?: string;
            last_name?: string;
            name?: string;
            session_id?: string;
            ip_address?: string;
            utm_source?: string;
            utm_medium?: string;
            utm_campaign?: string;
            utm_content?: string;
            fbclid?: string;
            gclid?: string;
            platform?: string;
            platform_id?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event/transaction',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get events
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @param id Visitor Id if you want to filter
     * @param limit Limit for pagination
     * @param offset Limit for pagination
     * @returns Event Successfully retrieved events
     * @throws ApiError
     */
    public static postEvent(
        workspaceId: string,
        requestBody: {
            start_date: string;
            end_date: string;
        },
        id?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<Event> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event',
            query: {
                'workspace_id': workspaceId,
                'id': id,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Event not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get conversion events
     * @param workspaceId Workspace ID is required in every request.
     * @param requestBody
     * @returns Event Successfully retrieved events
     * @throws ApiError
     */
    public static postEventConversion(
        workspaceId: string,
        requestBody: {
            event_name?: string;
            start_date: string;
            end_date: string;
            id?: string;
            visitor_id?: string;
            country?: string;
            device?: string;
            email?: string;
            first_name?: string;
            last_name?: string;
            phone?: string;
            first_page_id?: string;
            first_page_href?: string;
            first_website_id?: string;
            first_page_hostname?: string;
            first_source_id?: string;
            first_utm_source?: string;
            first_utm_medium?: string;
            first_utm_campaign?: string;
            first_utm_content?: string;
            first_ad_name?: string;
            first_ad_set_name?: string;
            first_ad_campaign_name?: string;
            first_channel_id?: string;
            first_channel_name?: string;
            last_page_id?: string;
            last_page_href?: string;
            last_website_id?: string;
            last_page_hostname?: string;
            last_source_id?: string;
            last_utm_source?: string;
            last_utm_medium?: string;
            last_utm_campaign?: string;
            last_utm_content?: string;
            last_ad_name?: string;
            last_ad_set_name?: string;
            last_ad_campaign_name?: string;
            last_channel_id?: string;
            last_channel_name?: string;
            limit?: number;
            offset?: number;
        },
    ): CancelablePromise<Event> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event/conversion',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
}
